import type { ReactNode } from 'react';
import { Loading } from '@linktivity/link-ui';

import AsyncState from '../AsyncState/AsyncState';

import styles from './trainResults.module.css';

export interface TrainResultsProps {
  active: boolean;
  loading: boolean;
  error: boolean;
  empty: boolean;
  loadFailedTitle: string;
  retryLabel: string;
  emptyMessage: string;
  children: ReactNode;
  onRetry: () => void;
}

const TrainResults = ({
  active,
  loading,
  error,
  empty,
  loadFailedTitle,
  retryLabel,
  emptyMessage,
  children,
  onRetry
}: TrainResultsProps) => {
  if (!active) return null;

  return (
    <div className={styles.results}>
      {loading && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
      {!loading && error && (
        <AsyncState
          status="error"
          title={loadFailedTitle}
          actionLabel={retryLabel}
          onAction={onRetry}
        />
      )}
      {!loading && !error && empty && (
        <AsyncState status="empty" message={emptyMessage} />
      )}
      {!loading && !error && !empty && children}
    </div>
  );
};

export default TrainResults;
